/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as WorkflowsRouteImport } from './app/routes/workflows'
import { Route as VerifyEmailRouteImport } from './app/routes/verify-email'
import { Route as TrustCenterRouteImport } from './app/routes/trust-center'
import { Route as SignupRouteImport } from './app/routes/signup'
import { Route as ShortcutsRouteImport } from './app/routes/shortcuts'
import { Route as SettingsRouteImport } from './app/routes/settings'
import { Route as SearchRouteImport } from './app/routes/search'
import { Route as ResetPasswordRouteImport } from './app/routes/reset-password'
import { Route as RegisterRouteImport } from './app/routes/register'
import { Route as ProjectsRouteImport } from './app/routes/projects'
import { Route as PoliciesRouteImport } from './app/routes/policies'
import { Route as MeRouteImport } from './app/routes/me'
import { Route as LoginRouteImport } from './app/routes/login'
import { Route as KnowledgeRouteImport } from './app/routes/knowledge'
import { Route as IntegrationsRouteImport } from './app/routes/integrations'
import { Route as InboxRouteImport } from './app/routes/inbox'
import { Route as ForgotPasswordRouteImport } from './app/routes/forgot-password'
import { Route as ExploreAiRouteImport } from './app/routes/explore-ai'
import { Route as ConfirmEmailChangeRouteImport } from './app/routes/confirm-email-change'
import { Route as ChangelogRouteImport } from './app/routes/changelog'
import { Route as CaptureRouteImport } from './app/routes/capture'
import { Route as ApprovalsRouteImport } from './app/routes/approvals'
import { Route as AiRouteImport } from './app/routes/ai'
import { Route as AgentsRouteImport } from './app/routes/agents'
import { Route as AccessDeniedRouteImport } from './app/routes/access-denied'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as WorkflowsIndexRouteImport } from './app/routes/workflows.index'
import { Route as TeamsIndexRouteImport } from './app/routes/teams.index'
import { Route as AgentsIndexRouteImport } from './app/routes/agents.index'
import { Route as WorkflowsWorkflowIdRouteImport } from './app/routes/workflows.$workflowId'
import { Route as TeamsTeamSlugRouteImport } from './app/routes/teams.$teamSlug'
import { Route as TasksTaskIdRouteImport } from './app/routes/tasks.$taskId'
import { Route as ShareTokenRouteImport } from './app/routes/share.$token'
import { Route as OauthConsentRouteImport } from './app/routes/oauth.consent'
import { Route as MyWorkRouteImport } from './app/routes/my.work'
import { Route as MyTimeRouteImport } from './app/routes/my.time'
import { Route as MyTasksRouteImport } from './app/routes/my.tasks'
import { Route as MyPinnedRouteImport } from './app/routes/my.pinned'
import { Route as MyMessagesRouteImport } from './app/routes/my.messages'
import { Route as MyContactsRouteImport } from './app/routes/my.contacts'
import { Route as MyCalendarRouteImport } from './app/routes/my.calendar'
import { Route as InvitesTokenRouteImport } from './app/routes/invites.$token'
import { Route as AgentsAgentIdRouteImport } from './app/routes/agents.$agentId'
import { Route as AccountBillingRouteImport } from './app/routes/account.billing'
import { Route as TeamsTeamSlugIndexRouteImport } from './app/routes/teams.$teamSlug.index'
import { Route as TeamsTeamSlugWebhooksRouteImport } from './app/routes/teams.$teamSlug.webhooks'
import { Route as TeamsTeamSlugTimeRouteImport } from './app/routes/teams.$teamSlug.time'
import { Route as TeamsTeamSlugDocsRouteImport } from './app/routes/teams.$teamSlug.docs'
import { Route as TeamsTeamSlugChatRouteImport } from './app/routes/teams.$teamSlug.chat'
import { Route as TeamsTeamSlugBillingRouteImport } from './app/routes/teams.$teamSlug.billing'
import { Route as InvitesTokenDeclineRouteImport } from './app/routes/invites.$token_.decline'
import { Route as InvitesTokenAcceptRouteImport } from './app/routes/invites.$token_.accept'
import { Route as TeamsTeamSlugProjectsProjectSlugRouteImport } from './app/routes/teams.$teamSlug.projects.$projectSlug'
import { Route as TeamsTeamSlugProjectsProjectSlugSettingsRouteImport } from './app/routes/teams.$teamSlug.projects.$projectSlug_.settings'
import { Route as TeamsTeamSlugProjectsProjectSlugTaskKeyRouteImport } from './app/routes/teams.$teamSlug.projects.$projectSlug.$taskKey'

const WorkflowsRoute = WorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustCenterRoute = TrustCenterRouteImport.update({
  id: '/trust-center',
  path: '/trust-center',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ShortcutsRoute = ShortcutsRouteImport.update({
  id: '/shortcuts',
  path: '/shortcuts',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesRoute = PoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreAiRoute = ExploreAiRouteImport.update({
  id: '/explore-ai',
  path: '/explore-ai',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailChangeRoute = ConfirmEmailChangeRouteImport.update({
  id: '/confirm-email-change',
  path: '/confirm-email-change',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptureRoute = CaptureRouteImport.update({
  id: '/capture',
  path: '/capture',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsIndexRoute = WorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkflowsRoute,
} as any)
const TeamsIndexRoute = TeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsRoute,
} as any)
const WorkflowsWorkflowIdRoute = WorkflowsWorkflowIdRouteImport.update({
  id: '/$workflowId',
  path: '/$workflowId',
  getParentRoute: () => WorkflowsRoute,
} as any)
const TeamsTeamSlugRoute = TeamsTeamSlugRouteImport.update({
  id: '/teams/$teamSlug',
  path: '/teams/$teamSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const MyWorkRoute = MyWorkRouteImport.update({
  id: '/my/work',
  path: '/my/work',
  getParentRoute: () => rootRouteImport,
} as any)
const MyTimeRoute = MyTimeRouteImport.update({
  id: '/my/time',
  path: '/my/time',
  getParentRoute: () => rootRouteImport,
} as any)
const MyTasksRoute = MyTasksRouteImport.update({
  id: '/my/tasks',
  path: '/my/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const MyPinnedRoute = MyPinnedRouteImport.update({
  id: '/my/pinned',
  path: '/my/pinned',
  getParentRoute: () => rootRouteImport,
} as any)
const MyMessagesRoute = MyMessagesRouteImport.update({
  id: '/my/messages',
  path: '/my/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const MyContactsRoute = MyContactsRouteImport.update({
  id: '/my/contacts',
  path: '/my/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const MyCalendarRoute = MyCalendarRouteImport.update({
  id: '/my/calendar',
  path: '/my/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesTokenRoute = InvitesTokenRouteImport.update({
  id: '/invites/$token',
  path: '/invites/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AgentsRoute,
} as any)
const AccountBillingRoute = AccountBillingRouteImport.update({
  id: '/account/billing',
  path: '/account/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsTeamSlugIndexRoute = TeamsTeamSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TeamsTeamSlugRoute,
} as any)
const TeamsTeamSlugWebhooksRoute = TeamsTeamSlugWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => TeamsTeamSlugRoute,
} as any)
const TeamsTeamSlugTimeRoute = TeamsTeamSlugTimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => TeamsTeamSlugRoute,
} as any)
const TeamsTeamSlugDocsRoute = TeamsTeamSlugDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => TeamsTeamSlugRoute,
} as any)
const TeamsTeamSlugChatRoute = TeamsTeamSlugChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => TeamsTeamSlugRoute,
} as any)
const TeamsTeamSlugBillingRoute = TeamsTeamSlugBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => TeamsTeamSlugRoute,
} as any)
const InvitesTokenDeclineRoute = InvitesTokenDeclineRouteImport.update({
  id: '/invites/$token_/decline',
  path: '/invites/$token/decline',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesTokenAcceptRoute = InvitesTokenAcceptRouteImport.update({
  id: '/invites/$token_/accept',
  path: '/invites/$token/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsTeamSlugProjectsProjectSlugRoute =
  TeamsTeamSlugProjectsProjectSlugRouteImport.update({
    id: '/projects/$projectSlug',
    path: '/projects/$projectSlug',
    getParentRoute: () => TeamsTeamSlugRoute,
  } as any)
const TeamsTeamSlugProjectsProjectSlugSettingsRoute =
  TeamsTeamSlugProjectsProjectSlugSettingsRouteImport.update({
    id: '/projects/$projectSlug_/settings',
    path: '/projects/$projectSlug/settings',
    getParentRoute: () => TeamsTeamSlugRoute,
  } as any)
const TeamsTeamSlugProjectsProjectSlugTaskKeyRoute =
  TeamsTeamSlugProjectsProjectSlugTaskKeyRouteImport.update({
    id: '/$taskKey',
    path: '/$taskKey',
    getParentRoute: () => TeamsTeamSlugProjectsProjectSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/agents': typeof AgentsRouteWithChildren
  '/ai': typeof AiRoute
  '/approvals': typeof ApprovalsRoute
  '/capture': typeof CaptureRoute
  '/changelog': typeof ChangelogRoute
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/explore-ai': typeof ExploreAiRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inbox': typeof InboxRoute
  '/integrations': typeof IntegrationsRoute
  '/knowledge': typeof KnowledgeRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/policies': typeof PoliciesRoute
  '/projects': typeof ProjectsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shortcuts': typeof ShortcutsRoute
  '/signup': typeof SignupRoute
  '/trust-center': typeof TrustCenterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/workflows': typeof WorkflowsRouteWithChildren
  '/account/billing': typeof AccountBillingRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/my/calendar': typeof MyCalendarRoute
  '/my/contacts': typeof MyContactsRoute
  '/my/messages': typeof MyMessagesRoute
  '/my/pinned': typeof MyPinnedRoute
  '/my/tasks': typeof MyTasksRoute
  '/my/time': typeof MyTimeRoute
  '/my/work': typeof MyWorkRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$token': typeof ShareTokenRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/teams/$teamSlug': typeof TeamsTeamSlugRouteWithChildren
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/invites/$token/accept': typeof InvitesTokenAcceptRoute
  '/invites/$token/decline': typeof InvitesTokenDeclineRoute
  '/teams/$teamSlug/billing': typeof TeamsTeamSlugBillingRoute
  '/teams/$teamSlug/chat': typeof TeamsTeamSlugChatRoute
  '/teams/$teamSlug/docs': typeof TeamsTeamSlugDocsRoute
  '/teams/$teamSlug/time': typeof TeamsTeamSlugTimeRoute
  '/teams/$teamSlug/webhooks': typeof TeamsTeamSlugWebhooksRoute
  '/teams/$teamSlug/': typeof TeamsTeamSlugIndexRoute
  '/teams/$teamSlug/projects/$projectSlug': typeof TeamsTeamSlugProjectsProjectSlugRouteWithChildren
  '/teams/$teamSlug/projects/$projectSlug/$taskKey': typeof TeamsTeamSlugProjectsProjectSlugTaskKeyRoute
  '/teams/$teamSlug/projects/$projectSlug/settings': typeof TeamsTeamSlugProjectsProjectSlugSettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/ai': typeof AiRoute
  '/approvals': typeof ApprovalsRoute
  '/capture': typeof CaptureRoute
  '/changelog': typeof ChangelogRoute
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/explore-ai': typeof ExploreAiRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inbox': typeof InboxRoute
  '/integrations': typeof IntegrationsRoute
  '/knowledge': typeof KnowledgeRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/policies': typeof PoliciesRoute
  '/projects': typeof ProjectsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shortcuts': typeof ShortcutsRoute
  '/signup': typeof SignupRoute
  '/trust-center': typeof TrustCenterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account/billing': typeof AccountBillingRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/my/calendar': typeof MyCalendarRoute
  '/my/contacts': typeof MyContactsRoute
  '/my/messages': typeof MyMessagesRoute
  '/my/pinned': typeof MyPinnedRoute
  '/my/tasks': typeof MyTasksRoute
  '/my/time': typeof MyTimeRoute
  '/my/work': typeof MyWorkRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$token': typeof ShareTokenRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/agents': typeof AgentsIndexRoute
  '/teams': typeof TeamsIndexRoute
  '/workflows': typeof WorkflowsIndexRoute
  '/invites/$token/accept': typeof InvitesTokenAcceptRoute
  '/invites/$token/decline': typeof InvitesTokenDeclineRoute
  '/teams/$teamSlug/billing': typeof TeamsTeamSlugBillingRoute
  '/teams/$teamSlug/chat': typeof TeamsTeamSlugChatRoute
  '/teams/$teamSlug/docs': typeof TeamsTeamSlugDocsRoute
  '/teams/$teamSlug/time': typeof TeamsTeamSlugTimeRoute
  '/teams/$teamSlug/webhooks': typeof TeamsTeamSlugWebhooksRoute
  '/teams/$teamSlug': typeof TeamsTeamSlugIndexRoute
  '/teams/$teamSlug/projects/$projectSlug': typeof TeamsTeamSlugProjectsProjectSlugRouteWithChildren
  '/teams/$teamSlug/projects/$projectSlug/$taskKey': typeof TeamsTeamSlugProjectsProjectSlugTaskKeyRoute
  '/teams/$teamSlug/projects/$projectSlug/settings': typeof TeamsTeamSlugProjectsProjectSlugSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/agents': typeof AgentsRouteWithChildren
  '/ai': typeof AiRoute
  '/approvals': typeof ApprovalsRoute
  '/capture': typeof CaptureRoute
  '/changelog': typeof ChangelogRoute
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/explore-ai': typeof ExploreAiRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inbox': typeof InboxRoute
  '/integrations': typeof IntegrationsRoute
  '/knowledge': typeof KnowledgeRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/policies': typeof PoliciesRoute
  '/projects': typeof ProjectsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shortcuts': typeof ShortcutsRoute
  '/signup': typeof SignupRoute
  '/trust-center': typeof TrustCenterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/workflows': typeof WorkflowsRouteWithChildren
  '/account/billing': typeof AccountBillingRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/my/calendar': typeof MyCalendarRoute
  '/my/contacts': typeof MyContactsRoute
  '/my/messages': typeof MyMessagesRoute
  '/my/pinned': typeof MyPinnedRoute
  '/my/tasks': typeof MyTasksRoute
  '/my/time': typeof MyTimeRoute
  '/my/work': typeof MyWorkRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$token': typeof ShareTokenRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/teams/$teamSlug': typeof TeamsTeamSlugRouteWithChildren
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/invites/$token_/accept': typeof InvitesTokenAcceptRoute
  '/invites/$token_/decline': typeof InvitesTokenDeclineRoute
  '/teams/$teamSlug/billing': typeof TeamsTeamSlugBillingRoute
  '/teams/$teamSlug/chat': typeof TeamsTeamSlugChatRoute
  '/teams/$teamSlug/docs': typeof TeamsTeamSlugDocsRoute
  '/teams/$teamSlug/time': typeof TeamsTeamSlugTimeRoute
  '/teams/$teamSlug/webhooks': typeof TeamsTeamSlugWebhooksRoute
  '/teams/$teamSlug/': typeof TeamsTeamSlugIndexRoute
  '/teams/$teamSlug/projects/$projectSlug': typeof TeamsTeamSlugProjectsProjectSlugRouteWithChildren
  '/teams/$teamSlug/projects/$projectSlug/$taskKey': typeof TeamsTeamSlugProjectsProjectSlugTaskKeyRoute
  '/teams/$teamSlug/projects/$projectSlug_/settings': typeof TeamsTeamSlugProjectsProjectSlugSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-denied'
    | '/agents'
    | '/ai'
    | '/approvals'
    | '/capture'
    | '/changelog'
    | '/confirm-email-change'
    | '/explore-ai'
    | '/forgot-password'
    | '/inbox'
    | '/integrations'
    | '/knowledge'
    | '/login'
    | '/me'
    | '/policies'
    | '/projects'
    | '/register'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/shortcuts'
    | '/signup'
    | '/trust-center'
    | '/verify-email'
    | '/workflows'
    | '/account/billing'
    | '/agents/$agentId'
    | '/invites/$token'
    | '/my/calendar'
    | '/my/contacts'
    | '/my/messages'
    | '/my/pinned'
    | '/my/tasks'
    | '/my/time'
    | '/my/work'
    | '/oauth/consent'
    | '/share/$token'
    | '/tasks/$taskId'
    | '/teams/$teamSlug'
    | '/workflows/$workflowId'
    | '/agents/'
    | '/teams/'
    | '/workflows/'
    | '/invites/$token/accept'
    | '/invites/$token/decline'
    | '/teams/$teamSlug/billing'
    | '/teams/$teamSlug/chat'
    | '/teams/$teamSlug/docs'
    | '/teams/$teamSlug/time'
    | '/teams/$teamSlug/webhooks'
    | '/teams/$teamSlug/'
    | '/teams/$teamSlug/projects/$projectSlug'
    | '/teams/$teamSlug/projects/$projectSlug/$taskKey'
    | '/teams/$teamSlug/projects/$projectSlug/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-denied'
    | '/ai'
    | '/approvals'
    | '/capture'
    | '/changelog'
    | '/confirm-email-change'
    | '/explore-ai'
    | '/forgot-password'
    | '/inbox'
    | '/integrations'
    | '/knowledge'
    | '/login'
    | '/me'
    | '/policies'
    | '/projects'
    | '/register'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/shortcuts'
    | '/signup'
    | '/trust-center'
    | '/verify-email'
    | '/account/billing'
    | '/agents/$agentId'
    | '/invites/$token'
    | '/my/calendar'
    | '/my/contacts'
    | '/my/messages'
    | '/my/pinned'
    | '/my/tasks'
    | '/my/time'
    | '/my/work'
    | '/oauth/consent'
    | '/share/$token'
    | '/tasks/$taskId'
    | '/workflows/$workflowId'
    | '/agents'
    | '/teams'
    | '/workflows'
    | '/invites/$token/accept'
    | '/invites/$token/decline'
    | '/teams/$teamSlug/billing'
    | '/teams/$teamSlug/chat'
    | '/teams/$teamSlug/docs'
    | '/teams/$teamSlug/time'
    | '/teams/$teamSlug/webhooks'
    | '/teams/$teamSlug'
    | '/teams/$teamSlug/projects/$projectSlug'
    | '/teams/$teamSlug/projects/$projectSlug/$taskKey'
    | '/teams/$teamSlug/projects/$projectSlug/settings'
  id:
    | '__root__'
    | '/'
    | '/access-denied'
    | '/agents'
    | '/ai'
    | '/approvals'
    | '/capture'
    | '/changelog'
    | '/confirm-email-change'
    | '/explore-ai'
    | '/forgot-password'
    | '/inbox'
    | '/integrations'
    | '/knowledge'
    | '/login'
    | '/me'
    | '/policies'
    | '/projects'
    | '/register'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/shortcuts'
    | '/signup'
    | '/trust-center'
    | '/verify-email'
    | '/workflows'
    | '/account/billing'
    | '/agents/$agentId'
    | '/invites/$token'
    | '/my/calendar'
    | '/my/contacts'
    | '/my/messages'
    | '/my/pinned'
    | '/my/tasks'
    | '/my/time'
    | '/my/work'
    | '/oauth/consent'
    | '/share/$token'
    | '/tasks/$taskId'
    | '/teams/$teamSlug'
    | '/workflows/$workflowId'
    | '/agents/'
    | '/teams/'
    | '/workflows/'
    | '/invites/$token_/accept'
    | '/invites/$token_/decline'
    | '/teams/$teamSlug/billing'
    | '/teams/$teamSlug/chat'
    | '/teams/$teamSlug/docs'
    | '/teams/$teamSlug/time'
    | '/teams/$teamSlug/webhooks'
    | '/teams/$teamSlug/'
    | '/teams/$teamSlug/projects/$projectSlug'
    | '/teams/$teamSlug/projects/$projectSlug/$taskKey'
    | '/teams/$teamSlug/projects/$projectSlug_/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessDeniedRoute: typeof AccessDeniedRoute
  AgentsRoute: typeof AgentsRouteWithChildren
  AiRoute: typeof AiRoute
  ApprovalsRoute: typeof ApprovalsRoute
  CaptureRoute: typeof CaptureRoute
  ChangelogRoute: typeof ChangelogRoute
  ConfirmEmailChangeRoute: typeof ConfirmEmailChangeRoute
  ExploreAiRoute: typeof ExploreAiRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InboxRoute: typeof InboxRoute
  IntegrationsRoute: typeof IntegrationsRoute
  KnowledgeRoute: typeof KnowledgeRoute
  LoginRoute: typeof LoginRoute
  MeRoute: typeof MeRoute
  PoliciesRoute: typeof PoliciesRoute
  ProjectsRoute: typeof ProjectsRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  ShortcutsRoute: typeof ShortcutsRoute
  SignupRoute: typeof SignupRoute
  TrustCenterRoute: typeof TrustCenterRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WorkflowsRoute: typeof WorkflowsRouteWithChildren
  AccountBillingRoute: typeof AccountBillingRoute
  InvitesTokenRoute: typeof InvitesTokenRoute
  MyCalendarRoute: typeof MyCalendarRoute
  MyContactsRoute: typeof MyContactsRoute
  MyMessagesRoute: typeof MyMessagesRoute
  MyPinnedRoute: typeof MyPinnedRoute
  MyTasksRoute: typeof MyTasksRoute
  MyTimeRoute: typeof MyTimeRoute
  MyWorkRoute: typeof MyWorkRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ShareTokenRoute: typeof ShareTokenRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  TeamsTeamSlugRoute: typeof TeamsTeamSlugRouteWithChildren
  TeamsIndexRoute: typeof TeamsIndexRoute
  InvitesTokenAcceptRoute: typeof InvitesTokenAcceptRoute
  InvitesTokenDeclineRoute: typeof InvitesTokenDeclineRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workflows': {
      id: '/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof WorkflowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust-center': {
      id: '/trust-center'
      path: '/trust-center'
      fullPath: '/trust-center'
      preLoaderRoute: typeof TrustCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shortcuts': {
      id: '/shortcuts'
      path: '/shortcuts'
      fullPath: '/shortcuts'
      preLoaderRoute: typeof ShortcutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies': {
      id: '/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof PoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore-ai': {
      id: '/explore-ai'
      path: '/explore-ai'
      fullPath: '/explore-ai'
      preLoaderRoute: typeof ExploreAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email-change': {
      id: '/confirm-email-change'
      path: '/confirm-email-change'
      fullPath: '/confirm-email-change'
      preLoaderRoute: typeof ConfirmEmailChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture': {
      id: '/capture'
      path: '/capture'
      fullPath: '/capture'
      preLoaderRoute: typeof CaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/': {
      id: '/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof WorkflowsIndexRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/teams/': {
      id: '/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof TeamsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/workflows/$workflowId': {
      id: '/workflows/$workflowId'
      path: '/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof WorkflowsWorkflowIdRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/teams/$teamSlug': {
      id: '/teams/$teamSlug'
      path: '/teams/$teamSlug'
      fullPath: '/teams/$teamSlug'
      preLoaderRoute: typeof TeamsTeamSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/work': {
      id: '/my/work'
      path: '/my/work'
      fullPath: '/my/work'
      preLoaderRoute: typeof MyWorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/time': {
      id: '/my/time'
      path: '/my/time'
      fullPath: '/my/time'
      preLoaderRoute: typeof MyTimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/tasks': {
      id: '/my/tasks'
      path: '/my/tasks'
      fullPath: '/my/tasks'
      preLoaderRoute: typeof MyTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/pinned': {
      id: '/my/pinned'
      path: '/my/pinned'
      fullPath: '/my/pinned'
      preLoaderRoute: typeof MyPinnedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/messages': {
      id: '/my/messages'
      path: '/my/messages'
      fullPath: '/my/messages'
      preLoaderRoute: typeof MyMessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/contacts': {
      id: '/my/contacts'
      path: '/my/contacts'
      fullPath: '/my/contacts'
      preLoaderRoute: typeof MyContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my/calendar': {
      id: '/my/calendar'
      path: '/my/calendar'
      fullPath: '/my/calendar'
      preLoaderRoute: typeof MyCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/$token': {
      id: '/invites/$token'
      path: '/invites/$token'
      fullPath: '/invites/$token'
      preLoaderRoute: typeof InvitesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/account/billing': {
      id: '/account/billing'
      path: '/account/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AccountBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/$teamSlug/': {
      id: '/teams/$teamSlug/'
      path: '/'
      fullPath: '/teams/$teamSlug/'
      preLoaderRoute: typeof TeamsTeamSlugIndexRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/webhooks': {
      id: '/teams/$teamSlug/webhooks'
      path: '/webhooks'
      fullPath: '/teams/$teamSlug/webhooks'
      preLoaderRoute: typeof TeamsTeamSlugWebhooksRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/time': {
      id: '/teams/$teamSlug/time'
      path: '/time'
      fullPath: '/teams/$teamSlug/time'
      preLoaderRoute: typeof TeamsTeamSlugTimeRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/docs': {
      id: '/teams/$teamSlug/docs'
      path: '/docs'
      fullPath: '/teams/$teamSlug/docs'
      preLoaderRoute: typeof TeamsTeamSlugDocsRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/chat': {
      id: '/teams/$teamSlug/chat'
      path: '/chat'
      fullPath: '/teams/$teamSlug/chat'
      preLoaderRoute: typeof TeamsTeamSlugChatRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/billing': {
      id: '/teams/$teamSlug/billing'
      path: '/billing'
      fullPath: '/teams/$teamSlug/billing'
      preLoaderRoute: typeof TeamsTeamSlugBillingRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/invites/$token_/decline': {
      id: '/invites/$token_/decline'
      path: '/invites/$token/decline'
      fullPath: '/invites/$token/decline'
      preLoaderRoute: typeof InvitesTokenDeclineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/$token_/accept': {
      id: '/invites/$token_/accept'
      path: '/invites/$token/accept'
      fullPath: '/invites/$token/accept'
      preLoaderRoute: typeof InvitesTokenAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/$teamSlug/projects/$projectSlug': {
      id: '/teams/$teamSlug/projects/$projectSlug'
      path: '/projects/$projectSlug'
      fullPath: '/teams/$teamSlug/projects/$projectSlug'
      preLoaderRoute: typeof TeamsTeamSlugProjectsProjectSlugRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/projects/$projectSlug_/settings': {
      id: '/teams/$teamSlug/projects/$projectSlug_/settings'
      path: '/projects/$projectSlug/settings'
      fullPath: '/teams/$teamSlug/projects/$projectSlug/settings'
      preLoaderRoute: typeof TeamsTeamSlugProjectsProjectSlugSettingsRouteImport
      parentRoute: typeof TeamsTeamSlugRoute
    }
    '/teams/$teamSlug/projects/$projectSlug/$taskKey': {
      id: '/teams/$teamSlug/projects/$projectSlug/$taskKey'
      path: '/$taskKey'
      fullPath: '/teams/$teamSlug/projects/$projectSlug/$taskKey'
      preLoaderRoute: typeof TeamsTeamSlugProjectsProjectSlugTaskKeyRouteImport
      parentRoute: typeof TeamsTeamSlugProjectsProjectSlugRoute
    }
  }
}

interface AgentsRouteChildren {
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
}

const AgentsRouteChildren: AgentsRouteChildren = {
  AgentsAgentIdRoute: AgentsAgentIdRoute,
  AgentsIndexRoute: AgentsIndexRoute,
}

const AgentsRouteWithChildren =
  AgentsRoute._addFileChildren(AgentsRouteChildren)

interface WorkflowsRouteChildren {
  WorkflowsWorkflowIdRoute: typeof WorkflowsWorkflowIdRoute
  WorkflowsIndexRoute: typeof WorkflowsIndexRoute
}

const WorkflowsRouteChildren: WorkflowsRouteChildren = {
  WorkflowsWorkflowIdRoute: WorkflowsWorkflowIdRoute,
  WorkflowsIndexRoute: WorkflowsIndexRoute,
}

const WorkflowsRouteWithChildren = WorkflowsRoute._addFileChildren(
  WorkflowsRouteChildren,
)

interface TeamsTeamSlugProjectsProjectSlugRouteChildren {
  TeamsTeamSlugProjectsProjectSlugTaskKeyRoute: typeof TeamsTeamSlugProjectsProjectSlugTaskKeyRoute
}

const TeamsTeamSlugProjectsProjectSlugRouteChildren: TeamsTeamSlugProjectsProjectSlugRouteChildren =
  {
    TeamsTeamSlugProjectsProjectSlugTaskKeyRoute:
      TeamsTeamSlugProjectsProjectSlugTaskKeyRoute,
  }

const TeamsTeamSlugProjectsProjectSlugRouteWithChildren =
  TeamsTeamSlugProjectsProjectSlugRoute._addFileChildren(
    TeamsTeamSlugProjectsProjectSlugRouteChildren,
  )

interface TeamsTeamSlugRouteChildren {
  TeamsTeamSlugBillingRoute: typeof TeamsTeamSlugBillingRoute
  TeamsTeamSlugChatRoute: typeof TeamsTeamSlugChatRoute
  TeamsTeamSlugDocsRoute: typeof TeamsTeamSlugDocsRoute
  TeamsTeamSlugTimeRoute: typeof TeamsTeamSlugTimeRoute
  TeamsTeamSlugWebhooksRoute: typeof TeamsTeamSlugWebhooksRoute
  TeamsTeamSlugIndexRoute: typeof TeamsTeamSlugIndexRoute
  TeamsTeamSlugProjectsProjectSlugRoute: typeof TeamsTeamSlugProjectsProjectSlugRouteWithChildren
  TeamsTeamSlugProjectsProjectSlugSettingsRoute: typeof TeamsTeamSlugProjectsProjectSlugSettingsRoute
}

const TeamsTeamSlugRouteChildren: TeamsTeamSlugRouteChildren = {
  TeamsTeamSlugBillingRoute: TeamsTeamSlugBillingRoute,
  TeamsTeamSlugChatRoute: TeamsTeamSlugChatRoute,
  TeamsTeamSlugDocsRoute: TeamsTeamSlugDocsRoute,
  TeamsTeamSlugTimeRoute: TeamsTeamSlugTimeRoute,
  TeamsTeamSlugWebhooksRoute: TeamsTeamSlugWebhooksRoute,
  TeamsTeamSlugIndexRoute: TeamsTeamSlugIndexRoute,
  TeamsTeamSlugProjectsProjectSlugRoute:
    TeamsTeamSlugProjectsProjectSlugRouteWithChildren,
  TeamsTeamSlugProjectsProjectSlugSettingsRoute:
    TeamsTeamSlugProjectsProjectSlugSettingsRoute,
}

const TeamsTeamSlugRouteWithChildren = TeamsTeamSlugRoute._addFileChildren(
  TeamsTeamSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessDeniedRoute: AccessDeniedRoute,
  AgentsRoute: AgentsRouteWithChildren,
  AiRoute: AiRoute,
  ApprovalsRoute: ApprovalsRoute,
  CaptureRoute: CaptureRoute,
  ChangelogRoute: ChangelogRoute,
  ConfirmEmailChangeRoute: ConfirmEmailChangeRoute,
  ExploreAiRoute: ExploreAiRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InboxRoute: InboxRoute,
  IntegrationsRoute: IntegrationsRoute,
  KnowledgeRoute: KnowledgeRoute,
  LoginRoute: LoginRoute,
  MeRoute: MeRoute,
  PoliciesRoute: PoliciesRoute,
  ProjectsRoute: ProjectsRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  ShortcutsRoute: ShortcutsRoute,
  SignupRoute: SignupRoute,
  TrustCenterRoute: TrustCenterRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WorkflowsRoute: WorkflowsRouteWithChildren,
  AccountBillingRoute: AccountBillingRoute,
  InvitesTokenRoute: InvitesTokenRoute,
  MyCalendarRoute: MyCalendarRoute,
  MyContactsRoute: MyContactsRoute,
  MyMessagesRoute: MyMessagesRoute,
  MyPinnedRoute: MyPinnedRoute,
  MyTasksRoute: MyTasksRoute,
  MyTimeRoute: MyTimeRoute,
  MyWorkRoute: MyWorkRoute,
  OauthConsentRoute: OauthConsentRoute,
  ShareTokenRoute: ShareTokenRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  TeamsTeamSlugRoute: TeamsTeamSlugRouteWithChildren,
  TeamsIndexRoute: TeamsIndexRoute,
  InvitesTokenAcceptRoute: InvitesTokenAcceptRoute,
  InvitesTokenDeclineRoute: InvitesTokenDeclineRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
